import type {paths} from '../../openapi/auth.swagger';
import {axiosInstance} from '../axiosInstance';

type SetSecretCodeOperation = paths['/executor_web/recovery/secret_code']['post'];

export type SetSecretCodeRequestBody = NonNullable<
	NonNullable<SetSecretCodeOperation['requestBody']>['content']['application/json']
>;
export interface SetSecretCodeRequest extends SetSecretCodeRequestBody {
	token: string;
}
export type SetSecretCodeResponse = SetSecretCodeOperation['responses'][200]['content']['application/json'];
export type SetSecretCodeErrorResponse =
	SetSecretCodeOperation['responses'][401]['content']['application/json'];

/** POST `/executor_web/recovery/secret_code` — см. `paths['/executor_web/recovery/secret_code']` в auth swagger */
export function setSecretCode(request: SetSecretCodeRequest, signal?: AbortSignal) {
	const {token, ...body} = request;

	return axiosInstance.post<SetSecretCodeResponse>('recovery/secret_code', body, {
		signal,
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}
